const sortByMap: any = {
    date: "publish_time",
    wifi_power: "wifi"
};

export function getSortByMap(value: string){
  return Object.prototype.hasOwnProperty.call(sortByMap, value) ? sortByMap[value] : value;
}